/* before.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./before.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
var beforeElementStyles = null;
var Before = function Before(_ref) {
  var elemBefore = _ref.elemBefore;
  return elemBefore ? /*#__PURE__*/React.createElement("span", {
    className: ax(["_1e0c1txw _4t3i7vkz _4cvr1h6o _1bah1h6o _152tze3t"])
  }, elemBefore) : null;
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Before;